import React, { useEffect, useState } from 'react';
import '../solutions/Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solutionCentralOffice.mp4",
    poster: "/videos/solutionCentralOffice.jpg",
    heading: "What are VSFF connectors and why should you use them",
    subheading: "Nov 12, 2024",
    buttonLink: "/support"
  }
];

function BlogVSFFConnectors() {

const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

const [open, setOpen] = useState();

  const toggle = (key) => {
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };


const productFamilies = [
  'Fiber Cable Assemblies',
  'Fiber Panels',
  'Frames',
];


const topByFamily = productFamilies.map(famName => {
  const matchingProducts = filteredProducts.filter(
    p => (p.productFamily || '').trim() === famName
  );
  if (matchingProducts.length === 0) return null;

  const topProduct = matchingProducts.reduce((best, current) =>
    Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
  );

  return { family: famName, topProduct };
}).filter(Boolean); // remove nulls if a family has no products



useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="curved-header-sol2" style={{paddingBottom: 60}}>
        <div className="datacenter-left" style={{ paddingTop: 100}}>
            <h1>{slides[0].heading}</h1>
            <p style={{ marginBottom: 40, fontSize: 20}}>{slides[0].subheading}</p>
            </div>
          <div className="datacenter-right"  style={{ paddingTop: 60}}>
              <img src="/images/blog/MMC-Connector-Image.png" className="datacenter-img" />
            </div>
            </div>


      <div className="blog-section-1" style={{ marginTop: 30}}>

          <p className="solution-section-1-description">VSFF stands for “very small form factor.” Creative right? Our industry loves acronyms. VSFF connectors are most often used in data centers where high density connectivity is extremely important to help reduce or make the most of real estate. VSFF connectors live up to their name and their small package doesn’t compromise on performance. VSFF connector performance is on par with their larger scale counterparts. And these connectors accommodate fiber cables 2.00mm or less in outer diameter.<br/><br/>

<b>Here are five key benefits of using VSFF connectors.</b><br/>

Fiber optic cables come in two main types: single-mode and multi-mode. Both types play vital roles in data centers.<br/><br/>

1. The small size provides more connections in the same space<br/><br/>
VSFF connectors (like US Conec MDC and Senko SN) are ~40% smaller than duplex LC, providing up to 3x higher density. The compact vertical TX/RX design enables up to 432 fibers in a 1U panel, maximizing data center efficiency while saving valuable space for high-density applications.<br/><br/>

2. Ease of installation and deployment speed<br/><br/>
VSFF connectors feature a convenient push-pull boot mechanism, allowing quick, secure connections with minimal effort. This design simplifies the installation process, reducing deployment time significantly—an essential advantage for large-scale data center setups or time-sensitive network expansions.<br/><br/>

3. Sustainability<br/><br/>
With the decreased size, less material is used compared to their connector counterparts.<br/><br/>

4. Direct breakout access<br/><br/>
Unlike MPO connectors, which typically require additional breakout cables or cassettes to separate individual fiber channels, VSFF connectors (like the MDC or SN) provide direct access to each fiber port. This level of granularity means you can connect directly to devices without intermediary components, simplifying the network setup, reducing hardware costs, and minimizing potential points of failure.<br/><br/>

5. Enabling high speeds and bandwidth<br/><br/>
As networks migrate to 400 and 800 gig, the connectivity supporting that transport needs to be robust. VSFF connectors support the bandwidth needs of 400G, 800G, and beyond, ensuring reliable, high-speed data transmission for AI, 5G, and modern networks.<br/><br/>

<img src="images/blog/VSFF.png" style={{height: 'auto', width: '80vw'}} /> <br/><br/>

If you’re looking to maximize your current infrastructure, transitioning to VSFF connectors is an excellent step. Here are a few things you should know.<br/><br/>

<b>Compatibility and Transitioning</b><br/>

VSFF connectors, like LC connectors, utilize the same 1.25mm ferrule, making it easier to integrate into existing systems with minimal adjustments.<br/><br/>

<b>Available VSFF Connector Types</b><br/>
The market offers several VSFF options including, CS, SN, and MDC connectors.<br/><br/>

<ul style={{margin: 0}}>
    <li>SN connectors: Ideal for high-density applications, featuring a compact design and pull-tab for easy access.</li>
    <li>MDC connectors: A duplex connector designed to maximize space savings while simplifying installations.</li>
  </ul><br/><br/>

<b>Cost Comparisons</b><br/>
Generally, VSFF connectors are cost-competitive with traditional options, offering long-term value through space savings, higher density, and reduced deployment costs.<br/><br/>

<b>Potential Challenges</b><br/>
It’s essential to note that SN and MDC connectors are NOT cross-compatible, so selecting the right type is crucial. Additionally, Go!Foton’s VSFF solutions are designed for broad compatibility, providing flexibility when planning transitions.<br/><br/>

Considering a move to VSFF can unlock both immediate and future benefits for your network infrastructure.<br/><br/>

<a
  className='cta-button'
  style={{marginTop: 10}}
  href='/fiber-cable-assemblies'
>Browse Patch Cords</a>
</p>
      </div>


        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions" style={{ backgroundColor: 'white'}}></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default BlogVSFFConnectors;
